import React from "react";
import { QRCode } from "@progress/kendo-react-barcodes";
import { convertToUtf8 } from "../../../../pdf-templates/utils";
import { QrCodeErrorBoundary } from "./qr-code-renderer.component";

interface QrCodeRawRendererProps {
	rawString: string;
}

export const QrCodeRawRenderer: React.FC<QrCodeRawRendererProps> = ({
	rawString,
}) => {
	if (!rawString || rawString.trim().length === 0) {
		return (
			<div className="border-2 border-gray-300 rounded-lg p-6 bg-gray-50">
				<p className="text-gray-600 text-center">
					Geben Sie einen QR-Code String ein, um ihn zu rendern.
				</p>
			</div>
		);
	}

	const qrReceiptUtf8Bytes = convertToUtf8(rawString);

	return (
		<QrCodeErrorBoundary inputString={rawString}>
			<div className="flex flex-col items-center gap-4">
				<div className="border-2 border-green-500 rounded-lg p-6 bg-white">
					<QRCode
						value={qrReceiptUtf8Bytes}
						errorCorrection="M"
						encoding="ISO_8859_1"
						overlay={{
							type: "swiss",
						}}
						style={{
							width: "200px",
							height: "200px",
						}}
					/>
				</div>
				<div className="bg-green-50 border border-green-200 rounded-lg p-4 w-full">
					<p className="text-green-800 font-medium text-center">
						QR-Code erfolgreich generiert
					</p>
				</div>
				<details className="w-full">
					<summary className="cursor-pointer text-sm text-gray-600 hover:text-gray-800 font-medium">
						Raw String anzeigen
					</summary>
					<pre className="mt-2 text-xs text-gray-700 bg-gray-100 p-4 rounded overflow-auto max-h-96">
						{rawString}
					</pre>
				</details>
				<details className="w-full">
					<summary className="cursor-pointer text-sm text-gray-600 hover:text-gray-800 font-medium">
						UTF-8 konvertierte Bytes anzeigen
					</summary>
					<pre className="mt-2 text-xs text-gray-700 bg-gray-100 p-4 rounded overflow-auto max-h-96">
						{qrReceiptUtf8Bytes}
					</pre>
				</details>
			</div>
		</QrCodeErrorBoundary>
	);
};
